// extracted by mini-css-extract-plugin
export default {"category":"Category_category__2mAUb","productsCardsContainer":"Category_productsCardsContainer__Bo3as","productsContainer":"Category_productsContainer__DgUVT"};